import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-communication-room',
    templateUrl: './communication-room.component.html',
    styleUrls: ['./communication-room.component.css'],
})
export class CommunicationRoomComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication-room/communication-room.component.ts